<div class="w-full categories">
  <div class="flex items-center relative">
    <button type="button" class="scroll-button prev-button absolute left-0" (click)="scrollPrev()">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
        <path
          d="M20.7097 6.12492C21.1002 6.51544 21.1002 7.14862 20.7097 7.53914L11.7501 16.4987L20.7097 25.4583C21.1002 25.8488 21.1002 26.4819 20.7097 26.8724C20.3191 27.263 19.6861 27.263 19.2955 26.8724L9.62883 17.2058C9.23831 16.8152 9.23831 16.1822 9.62883 15.7916L19.2955 6.12492C19.6861 5.7344 20.3191 5.7344 20.7097 6.12492Z"
          fill="#505760"
        />
      </svg>
    </button>

    <div class="scroll-container w-full mx-4 md:mx-8 lg:mx-10 flex overflow-x-scroll scroll-smooth" #scrollContainer>
      <div class="categories-item" [class.selected]="!selectedCategoryId()" (click)="selectCategory(null)">
        <img [src]="'assets/img/rewards/all-brands.svg'" class="w-6 h-6 md:w-8 md:h-8" alt="" />
        <p class="paragraph-small-text font-medium text-center w-full ellipsis">
          {{ 'rewards.all' | translate }}
        </p>
      </div>

      @for (category of categories(); track category.id) {
        <div
          class="categories-item"
          id="category-item-{{ category.id }}"
          [class.selected]="selectedCategoryId() === category.id"
          (click)="selectCategory(category.id)"
        >
          <img [src]="category.image" class="w-6 h-6 md:w-8 md:h-8" alt="" />
          <p class="paragraph-small-text font-medium text-center w-full ellipsis">
            {{ category.localizable_name | translate }}
          </p>
        </div>
      }
    </div>

    <button type="button" class="scroll-button next-button absolute right-0" (click)="scrollNext()">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
        <path
          d="M11.2903 26.8751C10.8998 26.4846 10.8998 25.8514 11.2903 25.4609L20.2499 16.5013L11.2903 7.5417C10.8998 7.15117 10.8998 6.5181 11.2903 6.12757C11.6809 5.73704 12.3139 5.73704 12.7045 6.12757L22.3712 15.7942C22.7617 16.1848 22.7617 16.8178 22.3712 17.2084L12.7045 26.8751C12.3139 27.2656 11.6809 27.2656 11.2903 26.8751Z"
          fill="#505760"
        />
      </svg>
    </button>
  </div>
</div>
